import { z } from 'zod'

export const RawCategories = [
  'wedding',
  'baby-shower',
  'birthday',
  'funeral',
  'other',
] as const

export const EventCategorySchema = z.enum(RawCategories)

export type EventCategory = z.infer<typeof EventCategorySchema>

/**
 * Schema for a GuestbookEventSchema
 */
export const GuestbookEventSchema = z.object({
  id: z.string(),
  title: z.string(),
  category: EventCategorySchema,
  otherCategory: z.string().optional(),
  date: z.string(),
  owner: z.string(),
  images: z.string().array(),
  welcomeHeader: z.string().optional(),
  welcomeMessage: z.string().optional(),
  closingHeader: z.string().optional(),
  closingMessage: z.string().optional(),
  isFeedPublic: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export type GuestbookEvent = z.infer<typeof GuestbookEventSchema>

export const InvitationSchema = z.object({
  eventId: z.string(),
  title: z.string(),
  message: z.string(),
  backgroundColor: z.string().optional(),
  fontColor: z.string().optional(),
  updatedAt: z.string(),
})

export type Invitation = z.infer<typeof InvitationSchema>

export const EntrySchema = z.object({
  id: z.string(),
  eventId: z.string(),
  images: z.string().array(),
  hidden: z.boolean().optional(),
  message: z.string().optional(),
  guestName: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export type Entry = z.infer<typeof EntrySchema>

export const IdResponseSchema = z.object({ id: z.string() })

export const UserSchema = z.object({
  id: z.string(),
  email: z.string(),
  street: z.string().optional(),
  street2: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  zipCode: z.string().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export type User = z.infer<typeof UserSchema>

export const SignedUrlRequestSchema = z.object({
  location: z.enum(['entries', 'events']),
  key: z.string(),
  action: z.enum(['delete', 'put']),
})

export type SignedUrlRequest = z.infer<typeof SignedUrlRequestSchema>
